<template>
  <div class="login-modal-wrapper" v-if="visible" @click.self="handleClose">
    <div class="login-modal">
      <!-- 左侧品牌与功能 -->
      <div class="login-left">
        <div class="login-title">不仅是智能LOGO设计</div>
        <div class="login-stats">
          助力 <b>2887W+</b> 个人使用　|　赢得 <b>11W+</b> 企业和商户信任
        </div>
        <div class="login-features">
          <div class="login-feature" v-for="(feature, index) in features" :key="index">
            <span class="icon">✔</span>{{ feature }}
          </div>
        </div>
        <img class="login-ai-img" src="@/assets/static/images/图像 192.png" alt="AI LOGO 设计">
      </div>

      <!-- 右侧登录表单 -->
      <div class="login-right">
        <div class="close-login" @click="handleClose">
           <img src="@/assets/static/images/70.png" alt="关闭">
        </div>
        <div class="login-tabs">
          <div 
            class="login-tab" 
            :class="{ active: loginType === 'code' }"
            @click="loginType = 'code'"
          >验证码登陆</div>
          <div 
            class="login-tab" 
            :class="{ active: loginType === 'password' }"
            @click="loginType = 'password'"
          >密码登陆</div>
        </div>

        <form class="login-form" @submit.prevent="handleSubmit">
          <input 
            class="login-input" 
            type="text" 
            v-model="phone" 
            placeholder="请输入您的手机号" 
            required
            pattern="^1[3-9]\d{9}$"
          >
          
          <template v-if="loginType === 'code'">
            <div class="login-form-row">
              <input 
                class="login-input" 
                type="text" 
                v-model="code" 
                placeholder="请输入验证码" 
                required
                style="flex:1;"
              >
              <button 
                type="button" 
                class="login-code-btn" 
                :disabled="countdown > 0"
                @click="getVerifyCode"
              >
                {{ countdown > 0 ? `${countdown}s后重试` : '获取验证码' }}
              </button>
            </div>
          </template>

          <template v-else>
            <input 
              class="login-input" 
              :type="showPassword ? 'text' : 'password'" 
              v-model="password" 
              placeholder="请输入密码" 
              required
            >
          </template>

          <button type="submit" class="login-btn" :disabled="loading">
            {{ loading ? '登录中...' : '登陆/注册' }}
          </button>
        </form>

        <div class="login-agree">
          <input type="checkbox" id="agree" v-model="agreed" required>
          <label for="agree">登陆即同意
            <a href="#" target="_blank" @click.prevent="showAgreement">《问鼎科技用户使用协议》</a>
          </label>
        </div>

        <!-- <img class="login-qrcode" src="@/assets/static/images/组 464.png" alt="微信二维码"> -->
      </div>
    </div>
  </div>
</template>

<script>
import { ref, defineComponent } from 'vue'
import { ElMessage } from 'element-plus'
import { GetMyselfInfoApi, loginApi, SendVerifycodeApi } from '@/api/index'

export default defineComponent({
  name: 'LoginModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:visible', 'login-success'],
  setup(props, { emit }) {
    const loginType = ref('code') // 'code' 或 'password'
    const phone = ref('')
    const code = ref('')
    const password = ref('')
    const agreed = ref(true) // 默认同意协议
    const loading = ref(false)
    const countdown = ref(0)
    const showPassword = ref(false)

    const features = [
      'LOGO智能生成',
      '大量海量图片',
      '海量设计模板',
      '全渠道商用授权'
    ]
// 处理关闭事件
const handleClose = () => {
  emit('update:visible', false)
}

    // 获取验证码
    const getVerifyCode = async () => {
      if (!/^1[3-9]\d{9}$/.test(phone.value)) {
        ElMessage.error('请输入正确的手机号')
        return
      }

      try {
        const res = await SendVerifycodeApi({
          phone: phone.value
        })

        if (res.data.success) {
          ElMessage.success(res.data.msg)
          countdown.value = 60
          const timer = setInterval(() => {
            countdown.value--
            if (countdown.value <= 0) {
              clearInterval(timer)
            }
          }, 1000)
        } else {
          ElMessage.error(res.data.msg)
        }
      } catch (error) {
        ElMessage.error('发送验证码失败，请稍后重试')
      }
    }

    // 处理登录提交
    const handleSubmit = async () => {
      if (!agreed.value) {
        ElMessage.warning('请先同意用户协议')
        return
      }

      if (!/^1[3-9]\d{9}$/.test(phone.value)) {
        ElMessage.error('请输入正确的手机号')
        return
      }

      loading.value = true
      try {
        const loginData = {
          phone: phone.value,
          platform: '2',
          version: '1.0.0',
          ...(loginType.value === 'code' ? { code: code.value } : { pwd: password.value })
        }

        const res = await loginApi(loginData)

        if (res.data.success) {
          // 保存用户信息
          localStorage.setItem('userInfo', JSON.stringify(res.data.data[0]))
          ElMessage.success(res.data.msg)
          
          console.log('🎉 LoginModal: 准备触发 login-success 事件')
          
          // 触发登录成功事件
          emit('login-success', {
            phone: phone.value,
            type: loginType.value,
            userInfo: res.data.data[0]
          })
          
          console.log('✅ LoginModal: login-success 事件已触发')
          
          // 尝试直接调用父组件方法（备用方案）
          setTimeout(() => {
            console.log('🔄 尝试直接调用父组件刷新方法...')
            // 通过全局事件总线或其他方式通知
            window.dispatchEvent(new CustomEvent('login-success', {
              detail: {
                phone: phone.value,
                type: loginType.value,
                userInfo: res.data.data[0]
              }
            }))
          }, 50) // 减少延迟到50ms
          
          // 关闭登录框
          emit('update:visible', false)
          

        } else {
          ElMessage.error(res.data.msg)
        }
      } catch (error) {
        ElMessage.error('登录失败，请稍后重试')
      } finally {
        loading.value = false
      }
    }

    // 显示用户协议
    const showAgreement = () => {
      // TODO: 实现显示用户协议的逻辑
      ElMessage.info('用户协议功能待实现')
    }

    // 获取用户信息
    const getUserInfo = async (data = {}) => {
      try {
        const res = await GetMyselfInfoApi(data)
        return res
      } catch (error) {
        console.error('获取用户信息失败:', error)
        return null
      }
    }

    return {
      loginType,
      phone,
      code,
      password,
      agreed,
      loading,
      countdown,
      showPassword,
      features,
      getVerifyCode,
      handleSubmit,
      showAgreement,
      getUserInfo,
      handleClose
    }
  }
})
</script>

<style scoped>
.login-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.login-modal {
  width: 850px;
  max-width: 90vw;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 8px 32px rgba(0,102,255,0.15);
  display: flex;
  overflow: hidden;
  animation: modalFadeIn 0.3s ease;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-left {
  width: 40%;
  background: linear-gradient(180deg, #6ecaff 0%, #2196f3 100%);
  padding: 48px 32px 0px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  color: #fff;
  position: relative;
}

.login-title {
  font-size: 25px;
  font-weight: 700;
  margin-bottom: 18px;
  text-align: center;
}

.login-stats {
  font-size: 10px;
  margin-bottom: 32px;
  text-align: center;
  color: #e3f2fd;
}
.close-login{
    position: absolute;
    top: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
}
.close-login img{
    width: 100%;
    height: 100%;
}
.login-features {
  display: grid;
  grid-template-columns: auto auto;
  gap: 18px 24px;
  margin-bottom: 32px;
  justify-content: center;
}

.login-feature {
  background: #fff;
  color: #222;
  border-radius: 12px;
  padding: 10px 10px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  text-align: center;
  min-width: 140px;
  margin-bottom: 0;
  border: 1px solid #FFFFFF;
  background: linear-gradient(130deg, #D5ECFA 0%, #CBDFFF 100%);
  border-radius: 10px;
}

.login-feature .icon {
  width: 20px;
  height: 20px;
  background: #2196f3;
  border-radius: 4px;
  margin-right: 8px;
  display: inline-block;
  color: #fff;
  text-align: center;
  line-height: 20px;
  font-size: 16px;
}

.login-ai-img {
  width: 310px;

  display: block;
}

.login-right {
  width: 60%;
  background: #fff;
  padding: 59px 42px 68px 56px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}

.login-tabs {
  display: flex;
  gap: 32px;
  margin-bottom: 32px;
  font-size: 18px;
  font-weight: 600;
}

.login-tab {
  color: #bdbdbd;
  cursor: pointer;
  border-bottom: 2.5px solid transparent;
  padding-bottom: 6px;
  transition: color 0.2s, border 0.2s;
}

.login-tab.active {
  color: #222;
  border-bottom: 5px solid #0066ff;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.login-input {
  height: 48px;
  border: 1.5px solid #e6e6e6;
  border-radius: 8px;
  font-size: 12px;
  padding: 0 16px;
  outline: none;
  background: #fafbfc;
  color: #333;
}

.login-input:focus {
  border-color: #2196f3;
}

.login-form-row {
  display: flex;
  gap: 12px;
}

.login-code-btn {
  height: 48px;
  padding: 0 18px;
  background: #fff;
  color: #0066ff;
  border: 1.5px solid #0066ff;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.login-code-btn:hover:not(:disabled) {
  background: #e6f0ff;
}

.login-code-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-btn {
  height: 48px;
  background: linear-gradient(90deg, #0066ff 0%, #338bff 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  margin-top: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.login-btn:hover:not(:disabled) {
  background: linear-gradient(90deg, #338bff 0%, #0066ff 100%);
}

.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.login-agree {
  margin-top: 18px;
  font-size: 13px;
  color: #bdbdbd;
  display: flex;
  align-items: center;
}

.login-agree input[type=checkbox] {
  margin-right: 6px;
}

.login-agree a {
  color: #0066ff;
  text-decoration: none;
  margin-left: 2px;
}

.login-qrcode {
  position: absolute;
  right: 18px;
  bottom: 18px;
  width: 80px;
  opacity: 0.85;
}

@media (max-width: 900px) {
  .login-modal {
    width: 90vw;
    max-height: 90vh;
    overflow-y: auto;
  }
  .login-left, .login-right {
    width: 100%;
    padding: 32px 10px;
  }
  .login-ai-img {
    width: 160px;
  }
  .login-qrcode {
    width: 60px;
    right: 8px;
    bottom: 8px;
  }
}

@media (max-width: 600px) {
  .login-modal {
    width: 95vw;
    margin: 10px;
    border-radius: 12px;
  }
  .login-left, .login-right {
    padding: 18px 4vw;
  }
  .login-title {
    font-size: 18px;
  }
  .login-tabs {
    font-size: 16px;
    gap: 18px;
  }
  .login-btn {
    font-size: 16px;
  }
}
</style> 